
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import qrCodeImg from '../Images/qrCode1.jpg'; 

const QRCodePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const amount = location.state?.amount || 0;
  const userId = location.state?.userId || null;

  const handleConfirmPayment = async () => {
    try {
      const res = await fetch('https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.w9l0l1/v1w2x2y19', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount, userId }),
      });

      const data = await res.json();
      if (data.status === 'success') {
        alert('Payment confirmed and saved!');
        navigate('/recharge');
      } else {
        alert('Failed to confirm payment.');
      }
    } catch (error) {
      console.error('Error confirming payment:', error);
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8f8f8'
    }}>
      <h2>Scan & Pay ₹{amount}</h2>
      <img
        src={qrCodeImg}
        alt="QR Code"
        style={{ width: '300px', height: '300px', marginBottom: '20px' }}
      />
      <button
        onClick={handleConfirmPayment}
        style={{ padding: '10px 20px', fontSize: '16px' }}
      >
        I Have Paid
      </button>
    </div>
  );
};

export default QRCodePage;
// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import qrCodeImg from '../Images/qrCode1.jpg'; 
// const QRCodePage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const amount = location.state?.amount || 0;
//   const userId = location.state?.userId || '';

//   const handleConfirmPayment = async () => {
//     try {
//       const res = await fetch('https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.w9l0l1/v1w2x2y19', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ userId, amount }),
//       });

//       const data = await res.json();
//       if (data.success) {
//         alert('Payment confirmed and balance updated!');
//         navigate('/recharge');
//       } else {
//         alert(data.message || 'Payment confirmation failed.');
//       }
//     } catch (err) {
//       console.error('Confirm payment error:', err);
//       alert('Server error.');
//     }
//   };

//   return (
//     <div style={{
//       height: '100vh',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       background: '#f2f2f2'
//     }}>
//       <h2>Scan to Pay ₹{amount}</h2>
//       <img
//         src={qrCodeImg}
//         alt="QR Code"
//         style={{ width: '300px', height: '300px', marginBottom: '20px' }}
//       />
//       <button
//         onClick={handleConfirmPayment}
//         style={{ padding: '10px 20px', fontSize: '16px', background: '#007bff', color: 'white' }}
//       >
//         I Have Paid
//       </button>
//     </div>
//   );
// };

// export default QRCodePage;

